import React from 'react';
import CustomLineChart from 'components/charts/lineChart';
import DotsLoading from 'components/loadings/dotsLoading';
import moment from 'jalali-moment';
import useGetChartPost from '../hooks/useGetChartPost';
interface PrepaymentChartProps {
  guid: string;
  app: 'farm' | 'wholesaler';
}
const PrepaymentChart = ({guid, app}: PrepaymentChartProps) => {
  const {postChartData, isLoading} = useGetChartPost(guid);
  return (
    <div className="w-full flex flex-col gap-4">
      <h4 className="flex items-center gap-2 text-gray-6 text-[16px] font-normal">
        <span className="w-2 h-2 flex rounded-full bg-primary" />
        آمار بازدید
      </h4>
      {isLoading ? (
        <>
          <DotsLoading />
        </>
      ) : (
        <>
          <CustomLineChart
            data={{
              labels: postChartData?.map(item =>
                moment(item.date).format('jYYYY/jMM/jDD'),
              ),
              datasets: [
                {
                  data: postChartData?.map(item => item.count),
                  borderColor: app === 'farm' ? '#F29E4C' : '#38B3B5',
                  fill: false,
                },
              ],
            }}
            yAxisTitleOption={{
              display: true,
              text: 'نفر',
              align: 'end',
              font: {size: 12, family: 'IRANSans'},
            }}
            yTick={{
              callback: function (label) {
                // when the floored value is the same as the value we have a whole number
                if (typeof label === 'number') {
                  if (Math.floor(label) === label) {
                    return label;
                  }
                }
              },
            }}
          />
        </>
      )}
    </div>
  );
};

export default PrepaymentChart;
